import React from "react";
import HairCheckComponent from "../components/hair-check/index";
import styles from "../assets/styles/_hairCheck.module.scss";

const HairCheckPage = () => {
    return (
        <div className={styles.hairCheckPage}>
            <HairCheckComponent />
        </div>
    );
};

export default HairCheckPage;